/**
 * @desc 根据物流属性类型编号查询
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.LogisticsAttrTypeResponseDto>;
export function request(attrtypeNo: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/logisticsAttrType/byUnique/${attrtypeNo}`, {
      method: "GET",

      ...options,
    }),
  );
}
